import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-right-panel-1-icon',
  templateUrl: './layout-layout-right-panel-1.component.html'
})
export class LayoutLayoutRightPanel1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
